import {Spinner, view} from '@sail/ui';
import {Text} from 'src/v2/components/common';
import {LinkButton} from 'src/v2/components/common/LinkButton';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {getExplorerUrl} from 'src/v2/util/getExplorerUrl';
import {getStore} from 'src/v2/state/store';
import type {SupportedNetwork} from 'src/types';

import {message, useIntl} from '@sail/intl';

const messages = {
  processingPayment: message({
    id: 'crypto.payins.v2.exchange_screen.processing_payment',
    description: 'Title shown when payment is being processed',
    defaultMessage: 'Your payment is being processed.',
  }),

  viewTransaction: message({
    id: 'crypto.payins.v2.exchange_screen.view_transaction',
    description: 'Link text to view transaction on network',
    defaultMessage: 'View transaction on network',
  }),
};

export const ExchangeTransactionProcessing = () => {
  const intl = useIntl();
  const store = getStore();
  const exchangeOption = store.useSelector((state) => state.exchangeOption);
  const livemode = store.useSelector((state) => state.livemode);
  const transactionHash = store.useSelector(
    (state) => state.transactionDetails?.blockchainTxId,
  );
  const network = store.useSelector(
    (state) => state.transactionDetails?.destinationNetwork,
  );

  const explorerUrl =
    transactionHash && network
      ? getExplorerUrl({
          network: network as SupportedNetwork,
          livemode,
          blockchainTxId: transactionHash,
        })
      : null;

  if (!exchangeOption) {
    throw new Error('exchangeOption is required');
  }

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        alignY: 'center',
        gap: 'medium',
      }}
    >
      <Spinner css={{width: 'large', height: 'space.900'}} />
      <Text type="title" css={{textAlign: 'center'}}>
        {intl.formatMessage(messages.processingPayment)}
      </Text>
      <view.div
        css={{
          stack: 'x',
          alignX: 'center',
          alignY: 'center',
          gap: 'small',
        }}
      >
        <WalletIcon
          walletOption={exchangeOption}
          width="24px"
          height="24px"
          borderRadius="large"
        />
        <Text type="heading">{exchangeOption.name}</Text>
      </view.div>
      {/* There won't be a transaction hash in testmode */}
      {explorerUrl ? (
        <LinkButton href={explorerUrl} target="_blank">
          {intl.formatMessage(messages.viewTransaction)}
        </LinkButton>
      ) : null}
    </view.div>
  );
};
